var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('navigation'),_vm._v(" "),_c('router-view'),_vm._v(" "),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container text-center"},[_c('img',{staticStyle:{"height":"30px"},attrs:{"src":"/img/footer.png"}})])])
}]

export { render, staticRenderFns }